export enum TopLevelMenuUrl {
  Home = '/',
  App = 'https://app.matematykagryzie.pl',
  Testimonials = '/opinie',
  Faq = '/najczęściej-zadawane-pytania',
}

// This will be in dropdown
export enum ContentUrl {
  Sheets = '/arkusze-maturalne-z-matematyki-podstawowej',
  Tables = '/tablice-maturalne-z-matematyki',
}

export enum LandingUrl {
  GeneralLandingPage = '/kurs-z-matematyki',
  MaturaRetake = '/popraw-mature-z-matematyki',
  // TODO: to implement
  // MaturaCourse = '/kurs-maturalny-z-matematyki-podstawowej',
  // ExamCourse = '/kurs-egzamin-osmoklasisty-z-matematyki',
}

export enum CheckoutUrl {
  Base = '/kup',
}

export enum LegalUrl {
  TermsOfUse = '/warunki-korzystania',
  PrivacyPolicy = '/polityka-prywatnosci',
  GDPR = '/klauzula-informacyjna-rodo',
}

export enum Url {
  ChooseCourse = '/wybierz-kurs',

  // Payment Confirmation
  PaymentConfirmation = '/potwierdzenie-platnosci',

  // Archive
  Tutoring = '/darmowe-grupowe-korepetycje-online-z-matematyki-podstawowej',
}
